import { render } from "./ProductInventory.vue?vue&type=template&id=027a3d94&ts=true"
import script from "./ProductInventory.vue?vue&type=script&lang=ts"
export * from "./ProductInventory.vue?vue&type=script&lang=ts"

import "./ProductInventory.vue?vue&type=style&index=0&id=027a3d94&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__